function ContactSection() {
  return (
    <footer className="relative bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">

        {/* Top Area — Four Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 lg:gap-14 mb-16 md:mb-20">
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Address
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <p className="text-sm text-foreground-600 leading-relaxed font-light">
              93 W 4th St
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed font-light mt-1">
              Hamilton
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed font-light mt-1">
              L9C 3M8
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              City
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <p className="text-sm text-foreground-600 leading-relaxed font-light">
              Hamilton
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Country
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <p className="text-sm text-foreground-600 leading-relaxed font-light">
              Canada
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <p className="text-sm text-foreground-600 leading-relaxed font-light">
              +1 4374753275
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed font-light mt-1">
              info@appscott.com
            </p>
          </div>
        </div>

        {/* Bottom Area — Large Decorative Text + Info */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 pt-12 border-t border-background-200/70">
          <div>
            <div className="flex items-baseline gap-3">
              <span className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-none tracking-tight">
                Built
              </span>
              <span className="font-heading text-5xl md:text-6xl lg:text-7xl font-light text-foreground-400 leading-none tracking-tight">
                for
              </span>
            </div>
            <div className="flex items-center gap-3 mt-1">
              <div className="w-10 md:w-14 h-px bg-accent-500/60"></div>
              <span className="text-xs md:text-sm text-foreground-500 font-light tracking-wide">
                Long-term technical excellence
              </span>
            </div>
          </div>
          <div className="flex flex-col items-end gap-4">
            <p className="text-xs text-foreground-500 font-light">
              &copy; {new Date().getFullYear()} Appscott LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-3">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500/40"></span>
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500/40"></span>
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500/40"></span>
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500/40"></span>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default ContactSection;